/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Loader, errorToast } from "../../../helpers";
import { useLazyGetNewsQuery } from "../../../service/Common";
import { News } from "../../../types/General";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Layout from "../../../layout";

const NewsListing = () => {
  const navigate = useNavigate();
  const [getNews, { isLoading }] = useLazyGetNewsQuery();
  const [news, setNews] = useState<News[]>([]);

  const getAllNews = async () => {
    try {
      const response = await getNews({}).unwrap();
      if (response?.statusCode === 200) {
        setNews(response?.data?.news);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      console.log(error);
    }
  };

  useEffect(() => {
    getAllNews();
  }, []);

  return (
    <Layout>
      <Loader isLoad={isLoading} />
      <main className="blogListing_page">
        <section className="blogListing_sc">
          <div className="conta_iner">
            <div className="head">
              <h1>Latest News</h1>
            </div>

            <div className="blogs_list gap_m">
              {news?.length ? (
                news?.map((item) => (
                  <article
                    className="single"
                    key={item?._id}
                    onClick={() => navigate(`/news-detail/${item?._id}`)}
                  >
                    <figure>
                      <img src={item?.newsImage || ""} alt="" />
                    </figure>
                    <div className="blog_info">
                      <p className="rounded">
                        {moment(item?.createdAt).format("ll")}
                      </p>
                      <h3>{item?.title || ""}</h3>
                      <p style={{ wordWrap: "break-word" }}>
                        {item?.description?.length >= 180
                          ? item?.description?.slice(0, 180) + "...."
                          : item?.description}
                      </p>
                      <span
                        className="btn_link"
                        onClick={() => navigate(`/news-detail/${item?._id}`)}
                      >
                        Read full article
                      </span>
                    </div>
                  </article>
                ))
              ) : (
                <p>No news found</p>
              )}
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default NewsListing;
